export default {
  es: {
    'app.login.index.btn.submit': 'Enviar',
    'app.login.index.label.email': 'Email',
    'app.login.index.label.password': 'Contraseña',
    'app.login.index.placeholder.email': 'mail@mail.com',
    'app.login.index.title': 'Construcciones Andia',
    'app.login.index.form.err.email': 'Por favor proporcione un email válido',
    'app.login.index.form.err.password': 'La contraseña es obligatoria',
  },
};